import { createFileRoute } from "@tanstack/react-router";
import { UmumPage } from "@/components/admin/ai-assistant/umum-page";
import { requireAdminFeature } from "@/middleware/admin-feature-guard";

export const Route = createFileRoute("/admin/ai-assistant/umum")({
	beforeLoad: requireAdminFeature("admin-ai-umum"),
	component: UmumPage,
});
